module.exports = __webpack_public_path__ + "img/about-me.0eeb1a7f.png";